import { allPass, isNil, isEmpty, pipe, prop, filter, any, equals, values, head, not } from 'ramda';

const hasValidValue = value => !isNil(value) && !isEmpty(value);

export const generateJob = jobName => ({
	name: jobName,
	highCommand: {},
	mediumCommand: {},
	lowCommand: {},
	role: {},
	title: {},
	experience: {},
	completed: false,
	typeVerb: null,
});

export const verifyJobIsCompleted = allPass([
	pipe(
		job => filter(
			levelKey => any(equals(true), values(prop(levelKey, job))),
			['highCommand', 'mediumCommand', 'lowCommand'],
		),
		head,
		isNil,
		not,
	),
	pipe(prop('role'), hasValidValue),
	pipe(prop('title'), hasValidValue),
	pipe(prop('experience'), hasValidValue),
]);



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/helpers/helpers.js